"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveScreenComponent = void 0;
const Noop = ({ children }) => children;
Noop.displayName = 'Noop';
/**
 * Given a route object, resolves and returns a screen component
 * @param route
 * @param BB
 */
const resolveScreenComponent = (route, BB) => {
    const componentName = route.component || route.screen || Noop;
    const Component = BB.Components.resolveFromCache(componentName);
    if (typeof componentName === 'string') {
        Component.displayName = componentName;
    }
    return Component;
};
exports.resolveScreenComponent = resolveScreenComponent;
